<template>
	<div id="" ref="">
		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('硬件编码')}}</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="devHdcode" disabled=true>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px;">{{getLangText('接收客户')}}</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="custName" @change="onCustNameChage">
		</div>

		<div class="Capt DIVNoSelect" style="flex:0 0 auto; width:240px; height:20px; margin-top:-10px; margin-left:180px; border:0px solid red; color:#eb5757;">{{custId}}</div>


		<div style="float:left; width:100%; height:40px; border:0px solid red; margin-top:10px;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:50px;" @click="onCancelClick">{{getLangText("取消")}}</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:50px; float:right;" @click="onOKClick">{{getLangText("确定")}}</div>
		</div>
	</div>
</template>

<script>

import cselect    from '../cf/cselect'

export default {
	name: 'devDevo',
	components:{
		cselect
	},
	data () {
		return {
			custId: "未匹配上客户",
			custName: "",
			devId: "",
			devHdcode: "",
		}
	},
	mounted: function(){
		this.devId         = this.$route.query.devId;
		this.devHdcode     = this.$route.query.devHdcode;
	},
	computed:{

	},
	methods:{
		onCustNameChage: function(){
			let body={custName: this.custName};
			this.doTrade( "POST", ServAddr+"/api/pub/custNameQry", this.onCustNameOK, true, body, null );
		},
		onCustNameOK: function( res ){
			this.appRoot.app.closeDlgRun();

			this.custId = "未匹配上客户"
			let data=res.body;
			if( data.code == 200 )
			{
				if( data.body.custId != null )

					 this.custId = data.body.custId;
				else this.custId = "未匹配上客户";
			}
		},
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
		onOKClick: function( res ){
			if( this.custId == null || parseInt(this.custId)==0 ) return;

			let body={ devId: parseInt(this.devId), devCustId: parseInt(this.custId) };
			this.doTrade( "POST", ServAddr+"/api/device/devDevo", this.onDevoOK, true, body, null );
		},
		onDevoOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, LangText("操作成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, LangText("操作失败"), this.CLR.Err, this.$parent.onPopWinClose, true );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// devDevo.vue?638c2344